import React from 'react';
import AppLogin from './components';

const Login = () => {
  return (
    <AppLogin />
  );
};

export default Login;
